import { render } from "./ProductDetailsModal.vue?vue&type=template&id=5fdeca3a&scoped=true"
import script from "./ProductDetailsModal.vue?vue&type=script&lang=js"
export * from "./ProductDetailsModal.vue?vue&type=script&lang=js"

import "./ProductDetailsModal.vue?vue&type=style&index=0&id=5fdeca3a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fdeca3a"]])

export default __exports__